import React from 'react';
import { Button } from '@m4b-design/components';
import { usePublicModule } from './index.ViewHook';
import { changeQuery } from '@/libs/url';
import { useHistory } from 'react-router-dom';
import { PagePathV2 } from '@features/types';
import { Tea } from '@features/libs/tea';
import { IconRightArrow } from '@arco-design/iconbox-react-m4b-next';
import { useTranslation } from '@jupiter/plugin-runtime/i18n';
import PublicModuleCardDefault from '@/assets/imgs/default/public_module_card_default.svg';

export const PublicModule = () => {
  const { moduleList } = usePublicModule();
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <div className="w-[1280px] mx-auto">
      {moduleList.map(module => (
        <div key={module.module_config_id}>
          <div className="flex justify-between mb-24 mt-[30px]">
            <div className="text-[#000] text-[24px] font-semibold">
              {module.name}
            </div>
            <div
              className="flex items-center cursor-pointer text-brand-normal text-p3-regular"
              onClick={() => {
                Tea('button_click', {
                  page_name: 'seller_university_homepage',
                  tab_name: 'home_config_module_entrance',
                  click_for: 'learn_more',
                  module_name: module.name,
                });
                history.push({
                  pathname: PagePathV2.ModuleLandingPage,
                  search: changeQuery({
                    config_id: `${module.module_config_id}`,
                    from: 'modules',
                  }),
                });
              }}>
              <span className="mr-8 font-semibold">
                {t('academy_homepage_grow_view_more')}
              </span>
              <IconRightArrow />
            </div>
          </div>
          <div className="flex gap-24">
            {module.learning_info?.map((info, index) => (
              <div
                key={info.learning_id}
                className="flex flex-1 max-w-[calc((100%-48px)/3)] gap-16 hover:shadow-downL p-16 rounded-[8px] bg-white cursor-pointer"
                onClick={() => {
                  Tea('button_click', {
                    page_name: 'seller_university_homepage',
                    tab_name: 'home_config_module_entrance',
                    click_for: 'content',
                    module_name: info.name,
                    content_id: info.learning_id,
                    index: index,
                  });
                  if (info.learning_id) {
                    history.push({
                      pathname: PagePathV2.CourseDetail,
                      search: changeQuery({
                        learning_id: String(info.learning_id),
                        from: 'modules',
                      }),
                    });
                  }
                }}>
                <img
                  className="w-[186px] h-[124px] rounded-[8px]"
                  src={info.image || PublicModuleCardDefault}
                />
                <div className="flex flex-col justify-between items-start w-full">
                  <div
                    className="font-semibold text-base text-neutral-text1 line-clamp-2"
                    title={info.name}>
                    {info.name}
                  </div>
                  <Button className="w-fit">
                    {t('academy_pop_public_entry', '阅读详情')}
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
